/* eslint-disable */
const agency = {};
agency.themeName = 'agency-theme';
agency.clientFolder = 'agency';
agency.title = 'Agency Auto Insurance';
agency.logoAlt = 'agency';
agency.logoImg = '';
agency.logoImgSecondary = '';
agency.phonePrimary = '(888)-912-2004';
agency.phonePrimaryCall = '1-###-###-####';
agency.rc2HeadLogoCaption = 'CarInsurance recommends';

agency.customHeader = 'pemco';
agency.customTitle = 'PEMCO';

agency.redirection = {
	CreateQuote: {
		patchAPI: '/quotes',
	},
	InsuranceInfo: {
		patchAPI: '#',
		pageAPI: 'pages/AFAutoIntro/',
	},
	VehicleInfo: {
		patchAPI: '#',
		pageAPI: 'pages/AFAutoVehicles/',
		pageAPIRC2: 'pages/WL2AutoRC2Vehicles/',
	},
	DriverInfo: {
		patchAPI: '#',
		pageAPI: 'pages/AFAutoDrivers/',
		pageAPIRC2: 'pages/WL2AutoRC2Drivers/',
	},
	DetailsInfo: {
		patchAPI: '#',
		pageAPI: 'pages/AFAutoDetails/',
		pageAPIRC2: '/pages/WL2AutoRC2PolicyDetails/',
	},
	Quotes: {
		patchAPI: '#',
		pageAPI: 'pages/wlautopriorinsurance/',
	},
	AddVehicle: {
		patchAPI: '#',
		pageName: 'AFAutoNewVehicle',
		pageAPI: 'rules/AddNewVehicle/QTE_VEH__Veh',
	},
	AddDriver: {
		patchAPI: '#',
		pageName: 'AFAutoNewDriver',
		pageAPI: 'rules/AddNewDriver/QTE_DRV__Drv',
	},
	AddIncident: {
		patchAPI: '#',
		pageName: 'AFAutoNewIncident',
		pageAPI: 'rules/AddNewQuoteIncident/QTE_QIN__Qin',
	},
	DeleteVehicle: {
		patchAPI: '#',
		pageAPI: 'rules/RemoveVehicle/',
	},
	DeleteDriver: {
		patchAPI: '#',
		pageAPI: 'rules/RemoveDriver/',
	},
	DeleteIncident: {
		patchAPI: '#',
		pageAPI: 'rules/RemoveQuoteIncident/',
	},
	VehicleInsights: {
		patchAPI: '#',
		pageAPI: 'api/VehicleInsights',
	},
	Checkout: {
		patchAPI: '#',
		pageAPI: 'pages/WL2AutoCheckout/',
	},
	Confirmation: {
		patchAPI: '#',
		pageAPI: 'pages/WL2AutoConfirmation/',
	},
	IpToZip: {
		pageAPI: 'api/ip2geo',
	},
	Zipfinder: {
		pageAPI: 'api/zipfinder',
	},
};

agency.vgs = {
	styles: {
		base: {
			border: '1px solid #BDBDBD',
			background: 'initial',
			'background-color': '#fff',
			'border-radius': '4px !important',
			'font-size': '1rem',
			color: '#757575',
			height: '50px',
			'font-family': "'Roboto', sans-serif",
			padding: '5px 8px 0 8px !important',
			transition:
				'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out',
			width: '100%',
			margin: '3px 0px 0px',
			'&:focus': {
				'background-color': '#fff',
				border: '2px solid #212121',
				// 'box-shadow': '0px 0px 4px 3px #949494 !important',
				// '-webkit-box-shadow': '0px 0px 4px 3px #949494 !important',
				'&.invalid.touched': {
					'border-color': '#BB0000',
				},
			},
			'::placeholder': {
				color: '#999',
			},
			'::-webkit-inner-spin-button': {
				'-webkit-appearance': 'none',
			},
			'::-webkit-outer-spin-button': {
				'-webkit-appearance': 'none',
			},
			'&.invalid.touched': {
				border: '1px solid #BB0000',
			},
			'&.invalid.dirty': {
				border: '1px solid #BB0000',
			},
		},
		cardIcon: {
			right: '16px',
			top: '28px',
		},
	},
};
agency.errorMessages = {
	rateFail: `<p><b>Oh no! Progressive was unable to provide a final premium.</b></p>
  <p>For assistance, speak with one of our licensed insurance agent at <a href="tel:19414622045">1-(941)-462-2045</a></p>`,
	orderFail: `<p><b>Oh no! Progressive was unable to to place your order.</b></p>
  <p>For assistance, speak with one of our licensed insurance agent at <a href="tel:19414622045">1-(941)-462-2045</a></p>`,
	networkFail: `<p><strong>500 Error - Oh no! We're sorry.</strong></p><p>It looks like something's wrong with this page. While we're diligently trying to fix this issue. For assistance, speak with one of our licensed insurance agents at <a href="tel:19414622045">1-(941)-462-2045</a>.</p>`,
};

// New agency flow start
agency.name = 'PEMCO Insurance Agency';
agency.headLine = 'Find insurance that fits <br class="break"> <span style="color:#00548e">your unique needs</span>';
agency.zipHeadLine = '<span class="fw-bold">Enter your zip</span> code to find coverage at a price that works for you.';
agency.address = 'San Mateo, CA';
agency.offerText =
	'Save hundreds with policies <br> tailored for your unique needs.';
agency.representativeName = 'Matt Compton';
agency.agencyDescription =
	'Our vast network of providers deliver competitive rates you can trust.';
agency.agencyAddress = 'Seattle, WA 98109';
agency.shoppingList = [
	{
		id: 1,
		title: 'Bundle (Auto & Home) Insurance',
	},
	{
		id: 2,
		title: 'Full Coverage Insurance',
	},
	{
		id: 3,
		title: 'Rideshare Insurance',
	},
	{
		id: 4,
		title: 'Young Drivers Insurance',
	},
	{
		id: 5,
		title: 'Liability Only Insurance',
	},
];
agency.whyInsurance = 'PEMCO Insurance Agency is here to help';
agency.whyInsuranceSubText = 'When it comes to insurance, we know there are lots of options out there. That&#39;s why we&#39;re dedicated to guiding you through your shopping experience, so you know what you’re getting.'
agency.chooseInsuranceList = [
	{
		id: 1,
		title: 'Licensed agent support',
		info: 'Each person you connect with throughout your insurance journey is a licensed agent, equipped with the knowledge and expertise to help you make the best choice for you.',
	},
	{
		id: 2,
		title: 'Trusted by drivers like you',
		info: 'We value people and relationships…, which means providing our customers with service, prices, and coverage options that put them first.',
	},
	{
		id: 3,
		title: 'The right fit for your ride',
		info: 'We partner with a wide network of carriers, so there&#39;s something for everyone, no matter what you need.',
	},
	{
		id: 4,
		title: 'Insure beyond the drive',
		info: 'As an insurance destination, we&#39;ll help you find coverage for your home (including earthquake and flood insurance), your toys (including ATVs and RVs), and even your furry family members.',
	},
];
agency.howItWorksTitle = 'How it works'
agency.howItWorks = [
	{
		id: 1,
		img: 'basic-info-icon',
		title: 'Step 1:',
		info: '<strong>Provide basic information</strong> to secure a quote',
	},
	{
		id: 2,
		img: 'shop-compare-icon',
		title: 'Step 2:',
		info: '<strong>Shop and compare</strong> your customized rates from each available carrier',
	},
	{
		id: 3,
		img: 'purchase-icon',
		title: 'Step 3:',
		info: '<strong>Select and purchase</strong> your policy in a fully online process',
	},
	{
		id: 4,
		img: 'agentsupport-icon',
		title: 'Step 4:',
		info: '<strong>Get agent support through every step.</strong> We’re standing by to ensure you find a policy for your unique needs.',
	},
];
agency.readyToGetStartd = 'Ready to get started?';
agency.zipHeadLine2 = 'Enter your zip code to compare competitive quotes side by side.';
agency.CTAtitle2 = 'Get a quote today'
agency.contact = [
	{
		id: 1,
		category: 'ADDRESS',
		value:
			'1300 Dexter Avenue N. <br> Seattle, WA 98109-357 <br> <i>Please note: Onsite services are not available at our offices at this time</i>',
	},
	{
		id: 2,
		category: 'PHONE',
		value: '',
		value:
			'<a class="c-color" href="tel:(888)-912-2004" >(800)-MY-PEMCO (888)-912-2004</a>',
	},
	{
		id: 3,
		category: 'WEBSITE',
		value: '',
		value:
			'<a class="c-color" href="https://www.pemco.com/specialty" target="_blank">www.pemco.com/specialty</a>',
	},
];
agency.officeHoursTitle = 'OFFICE HOURS';
agency.officeHours = [
	{
		id: 1,
		day: 'Monday',
		availability: '8:00 AM-5:30 PM PST',
	},
	{
		id: 2,
		day: 'Tuesday',
		availability: '8:00 AM-5:30 PM PST',
	},
	{
		id: 3,
		day: 'Wednesday',
		availability: '8:00 AM-5:30 PM PST',
	},
	{
		id: 4,
		day: 'Thursday',
		availability: '8:00 AM-5:30 PM PST',
	},
	{
		id: 5,
		day: 'Friday',
		availability: '8:00 AM-5:30 PM PST',
	},
	{
		id: 6,
		day: 'Saturday',
		availability: 'Closed',
	},
	{
		id: 7,
		day: 'Sunday',
		availability: 'Closed',
	},
];

agency.aboutAgencyInsuranceTitle = 'PEMCO Insurance Agency';
agency.resultsFor = 'Results for';
agency.aboutAgencyInsuranceDescription = [
	{
		id: 1,
		info: 'PEMCO Insurance Agency Inc. is wholly owned by PEMCO Mutual Insurance Company. We’ve been helping our customers find the right coverage for over 50 years.',
	},
	{
		id: 2,
		info: 'We value relationships, your experience matters to us and you’ll always be a person, not a policy number. Everyone you connect with throughout your insurance journey is a licensed agent, equipped and prepared to serve you.',
	},
];
agency.shParameters={
	primaryColor:'212121', 
	buttonFontColor:'ffffff', 
	buttonHoverColor:'BB0000',
	buttonColor:'BB0000'
}
// New agency flow end

export default agency;
